export default __webpack_public_path__ + "static/media/ISCO CLASS-1 EXAM PATTERN 2025.721f3b4b.pdf";